import React from 'react';
import { Image, Container, Row, Col } from 'react-bootstrap'
import './index.css'
import Banner from '../../../assets/images/banner.png'
import TitleLight from '../../Text/TitleLight';
import i18n from '../../../locales';
import TitleBold from '../../Text/TitleBold';
import MainStyles from '../../../styles/MainStyles';

const BannerHeader = (props) => {
    return (
      <div style={{maxHeight: '55vh', overflow: 'hidden', position: 'relative'}}>
        <div className='container-texts'>
        <Container fluid="md">
          <Row>
            <Col xs={{span: 10, offset: 1}}>
            <TitleLight 
            text={i18n.t('general.title')}
            color={MainStyles.colors.white}
            size={'huge'}
          />
          <br/>
          <br/>
          <TitleBold 
            text={i18n.t('general.brand')}
            color={MainStyles.colors.white}
            size={'huge'}
          />
            </Col>
          
          </Row>
          
          </Container>
        </div>
        <Image className='banner-image' src={Banner}/>
      </div>
    )
}

export default BannerHeader
